import type { PixelModule } from '@/runtime/types';
import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

import {
  FingerprintEngine,
  PageViewEngine,
  SessionEngine,
  UrlContextEngine,
  VisitorEngine,
} from './engines';

export class CoreModule implements PixelModule {
  readonly name = 'core' as const;

  private urlContextEngine: UrlContextEngine | null = null;

  private visitorEngine: VisitorEngine | null = null;

  private sessionEngine: SessionEngine | null = null;

  private fingerprintEngine: FingerprintEngine | null = null;

  private pageViewEngine: PageViewEngine | null = null;

  init(context: PixelRuntimeContext): void {
    context.logger.debug('[Pixel] Core module initialized');

    // UrlContext ANTES do PageView — primeiro PAGE_VIEW já sai enriquecido.
    this.urlContextEngine = new UrlContextEngine(context);
    this.visitorEngine = new VisitorEngine(context);
    this.sessionEngine = new SessionEngine(context);
    this.fingerprintEngine = new FingerprintEngine(context);
    this.pageViewEngine = new PageViewEngine(context);

    this.urlContextEngine.init();
    this.visitorEngine.init();
    this.sessionEngine.init();
    this.fingerprintEngine.init();
    this.pageViewEngine.init();
  }

  destroy(): void {
    this.pageViewEngine?.destroy();
    this.fingerprintEngine?.destroy();
    this.sessionEngine?.destroy();
    this.visitorEngine?.destroy();
    this.urlContextEngine?.destroy();

    this.pageViewEngine = null;
    this.fingerprintEngine = null;
    this.sessionEngine = null;
    this.visitorEngine = null;
    this.urlContextEngine = null;
  }
}
